<!-- Migrated from pages/alerts-v2/pages/alert-v2-create/alert-v2-create.component.html
     (create-only, dialog layout: full-width name on top, no v2.0 toggle, no policy mode). -->
<ng-container *ngrxLet="selectSettings;let settings">
  <div class="create-alert-result flex-col start-start gap-16">
    <div class="create-alert-name w-100" [formGroup]="settingsForm">
      <input [placeholder]="'SEARCH_GLOBAL_MODAL.ALERT_CONFIGURATIONS.NAME_PLACEHOLDER' | translate"
        formControlName="name" class="ui-input w-100">
    </div>
    <div class="flex-row flex-wrap start-center gap-10 w-100">
      <div class="flex-row start-center" [formGroup]="settingsForm">
        @if (!isTemplate) {
        <step-option-selector [placeholder]="'ALERT_TEMPLATES.ALERT_GROUP.WHEN_THIS_HAPPEN'|translate"
          formControlName="type" [options]="AlertV2Type" [optionsGroups]="AlertV2TypeGroup"
          [selectionStr]="AlertV2TypeSelectionStr" [filterEnabled]="true"></step-option-selector>
        } @else {
        <div class="step-pretext">
          {{ sentenceStart|translate }}
        </div>
        }
      </div>
      <ng-container *ngIf="selectedAlertFlow" [formGroup]="configurationForm">
        <ng-container *ngFor="let step of selectedAlertFlow.steps; let i = index;">
          <div *ngIf="i <= currentStep" class="step flex-row start-center gap-10">
            <div *ngIf="!!step?.preText" class="step-pretext">{{ step.preText|translate }}</div>
            <ng-container [ngSwitch]="step.stepType">
              <ng-container *ngSwitchCase="StepType.SELECTOR">
                <step-option-selector [placeholder]="step.options?.placeholder" [multiple]="step.options?.multiple"
                  [value]="step?.value" [options]="step.options?.options" [optionsStr]="step.options?.optionsStr"
                  [selectionStr]="step.options?.selectionStr" [filterEnabled]="step.options?.filterEnabled"
                  [panelClass]="step.options?.panelClass" (change)="update(i, $event)"
                  [numberControl]="step.options?.numberControl" [stringOptions]="step.options?.stringOptions"
                  [optionsKeyValuePair]="step.options?.optionsKeyValuePair"
                  [disable]="step.options?.disable"></step-option-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.COUNTER">
                <step-counter [options]="step.options" [value]="step.value"
                  (change)="update(i, $event)"></step-counter>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.RANGE">
                <step-range-selector [options]="step.options" [value]="step.value"
                  (change)="update(i, $event)"></step-range-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.CAMERA_PICKER">
                @if (!isVersion20()) {
                  <step-camera-selector
                    [selectedCameras]="step.options?.edgeOnlySelect ? [] : step.value"
                    [selectedEdges]="step.options?.edgeOnlySelect ? (step.value ?? []) : []"
                    [options]="step?.options"
                    (change)="update(i, $event)"
                    [showZonesSelector]="selectedFlowCategory !== AlertCategory.Status"></step-camera-selector>
                } @else {
                  <step-zone-region-selector
                    [selectedZoneRegionGroups]="selectedZoneRegionGroups()"
                    (change)="onZoneRegionChange(i, $event)">
                  </step-zone-region-selector>
                }
              </ng-container>
              <ng-container *ngSwitchCase="StepType.SCHEDULE_PICKER">
                <ui-schedule-picker [formControl]="scheduleIdControl" [allowCustom]="true"
                  [customSchedule]="step.value" [showCreateScheduleOption]="true" [showAllTimesOption]="true"
                  [allTimesLabel]="'ALARM_CREATE.ALL_TIMES'"
                  (selectionChange)="onScheduleStepChange(i, $event)"
                  (customScheduleChange)="onCustomScheduleChange(i, $event)"
                  [sentenceView]="true"></ui-schedule-picker>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.SHELF_PICKER">
                <ui-shelf-picker [formControl]="$any(configurationForm.get(step.formControlName))" (change)="updateShelves(i, $event)"></ui-shelf-picker>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.OBJECTS_PICKER">
                <step-objects-selector [placeholder]="step.options?.placeholder" [multiple]="step.options?.multiple"
                  [displayAnd]="step.options?.displayAnd" [value]="step?.value"
                  [filterEnabled]="step.options?.filterEnabled"
                  [preconfiguredValue]="step.options?.preconfiguredValue"
                  [customObjectsControl]="selectedAlertFlow?.form?.get('customObjects')"
                  (change)="update(i, $event)"></step-objects-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.PLATE_PICKER">
                <step-plate-selector
                  *ngIf="lprUiMode === LprUiMode.LegacyPlates"
                  [value]="platesValue"
                  (change)="update(i, $event)"
                ></step-plate-selector>
                <step-vehicle-selector
                  *ngIf="lprUiMode === LprUiMode.Vehicles"
                  [vehicles]="vehiclesValue"
                  [vehicleGroups]="vehicleGroupsValue"
                  (change)="updateVehicleSelection(i, $event)"
                ></step-vehicle-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.CONTAINER_PICKER">
                <step-container-selector [value]="step.value" (change)="update(i, $event)"></step-container-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.PEOPLE_PICKER">
                <step-people-selector
                  [value]="step.value"
                  [personGroups]="selectedAlertFlow?.form?.get('personGroups')?.value ?? []"
                  (change)="update(i, $event)"
                  (personGroupsChange)="selectedAlertFlow?.form?.get('personGroups')?.setValue($event)"
                ></step-people-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.DOOR_PICKER">
                <step-doors-selector [selectedDoors]="step.value" [options]="step?.options"
                  (change)="update(i, $event)"></step-doors-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.ARM_DISARM_PICKER">
                <alert-groups-picker [alertGroups]="selectAlertGroups$|ngrxPush" [alertGroupId]="step?.value"
                  (onAlertGroupSelected)="update(i, $event)">
                </alert-groups-picker>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.NOTIFICATION_MSG">
                <notification-msg [initValue]="step.value" [placeholder]="step.options?.placeholder"
                  [variablesEnabled]="step.options?.variablesEnabled"
                  [variablesAutoComplete]="selectVariablesAutoComplete$|async"
                  (change)="update(i, $event)"></notification-msg>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.EVENT_TAG_PICKER">
                <step-option-selector [placeholder]="step.options?.placeholder"
                  [multiple]="false" [value]="step?.value" [options]="eventTagIds" [optionsArr]="eventTagIds"
                  [optionsKeyValuePair]="eventTagsKeyValuePairs" [optionsStr]="eventTagNames"
                  [selectionStr]="eventTagNames" [filterEnabled]="true" [stringOptions]="true"
                  [panelClass]="step.options?.panelClass" (change)="update(i, $event)"></step-option-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.INPUT">
                <step-input [options]="step.options" [value]="step.value" (change)="update(i, $event)"></step-input>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.ACCESS_DOOR_PICKER">
                <step-access-door-selector [selectedDoors]="step?.value" [options]="step?.options"
                  (change)="update(i, $event)"></step-access-door-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.PHYSICAL_ACCESS_DOOR_PICKER">
                <step-physical-access-door-picker [selectedDoor]="step?.value"
                  (change)="update(i, $event)"
                  (doorSelected)="onPhysicalDoorSelected($event)"></step-physical-access-door-picker>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.DOOR_CAMERA_PICKER">
                <step-door-camera-picker [selectedCamera]="step?.value"
                  [selectedDoor]="selectedPhysicalDoor"
                  (change)="update(i, $event)"></step-door-camera-picker>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.OBJECT_STATES_PICKER">
                <step-object-states-selector [value]="step?.value"
                  (change)="update(i, $event)"
                  (objectStateSelected)="onObjectStateSelected($event)"></step-object-states-selector>
              </ng-container>
              <ng-container *ngSwitchCase="StepType.STATE_SELECTOR">
                <step-state-selector [value]="step?.value"
                  [states]="selectedObjectStateStates"
                  (change)="update(i, $event)"></step-state-selector>
              </ng-container>
            </ng-container>
            <div *ngIf="step.suffixText" class="step-suffix">{{ step.suffixText | translate}}</div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div *ngIf="selectedAlertFlow && currentStep >= selectedAlertFlow?.steps?.length - 1 && selectedFlowCategory !== AlertCategory.ArmDisarm"
      class="icon-16 flex-row start-center">
      <span class="step-pretext">{{ 'ALERT_TEMPLATES.PRE_TEXT.USE'|translate }}</span>
      <div class="settings-sentence" (click)="openSettings()">
        {{ isDefaultSettings(settings) ? ('ALERT_TEMPLATES.SETTINGS_TYPE.DEFAULT'|translate) :
        ('ALERT_TEMPLATES.SETTINGS_TYPE.CUSTOM'|translate) }}
      </div>
    </div>

    <ng-container *ngIf="selectedAlertFlow && currentStep >= selectedAlertFlow?.steps?.length - 1">
      <div class="flex-row center-center alert-icon-button">
        <span class="ui-icon-arrow-down"></span>
      </div>
      <div class="flex-col start-start w-100 child-100 gap-10">
        <div class="flex-col gap-10" *ngFor="let action of actions; let i = index">
          <div class="flex-row start-center gap-10">
            <div *ngrxLet="selectHasSpeakers$; let hasSpeakers" class="flex-row flex-wrap start-center gap-10">
              <step-option-selector *ngIf="AlertV2CallGroup$ | async as groups"
                [placeholder]="'ALERT_TEMPLATES.THEN_DO'|translate" [value]="action.callData"
                [(ngModel)]="action.callData" (ngModelChange)="loadActionFlow(i, action?.form?.value, $event)"
                [optionsGroups]="groups" [disableOptions]="disableOptions"
                [filterEnabled]="true"></step-option-selector>
              <ng-container *ngFor="let step of action.steps; let stepIndex = index">
                <div *ngIf="step.preText" class="step-pretext">{{ step.preText|translate }}</div>
                <ng-container [ngSwitch]="step.stepType" [formGroup]="action.form">
                  <ng-container *ngSwitchCase="StepType.SELECTOR">
                    <step-option-selector [placeholder]="step.options?.placeholder"
                      [value]="step?.value ?? step?.options?.value" [formControlName]="step?.formControlName"
                      [options]="step.options?.options" [optionsStr]="step.options?.optionsStr"
                      [selectionStr]="step.options?.selectionStr" [filterEnabled]="step.options?.filterEnabled"
                      [lowerCase]="step.options?.lowerCase" [stringOptions]="step.options?.stringOptions"
                      [optionsKeyValuePair]="step.options?.optionsKeyValuePair"></step-option-selector>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.RANGE">
                    <step-range-selector [options]="step.options" [value]="step.value"
                      (change)="updateAction(action, stepIndex, $event)"></step-range-selector>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.COUNTER">
                    <step-counter [options]="step.options" [value]="step.value"
                      (change)="updateAction(action, stepIndex, $event)"></step-counter>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.INPUT">
                    <step-input [options]="step.options" [value]="step.value"
                      (change)="updateAction(action, stepIndex, $event)"></step-input>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.NOTIFICATION_PICKER">
                    <step-notifications [initValue]="step.value"
                      (change)="updateAction(action, stepIndex, $event)"></step-notifications>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.NOTIFICATION_MSG">
                    <step-notification-msg [action]="action" [placeholder]="step.options?.placeholder"
                      [onlyText]="step.options?.onlyText ?? false" [variablesEnabled]="step.options?.variablesEnabled"
                      [variablesAutoComplete]="selectVariablesAutoComplete$|async" [isPanicEvent]="isPanicEvent"
                      (change)="updateNotifyAction(action, stepIndex, $event)"></step-notification-msg>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.PROVIDER_PARAMS_PICKER">
                    <ng-container [ngSwitch]="action.form.value['provider']">
                      <ng-container *ngSwitchCase="'webhook'">
                        <step-http-request-picker [httpRequests]="selectHttpRequests$|ngrxPush"
                          [webhookId]="step?.value?.webhookId"
                          (onHttpRequestSelected)="updateAction(action, stepIndex, $event)">
                        </step-http-request-picker>
                      </ng-container>
                      <ng-container *ngSwitchCase="'microsoftTeams'">
                        <step-microsoft-teams-picker [channels]="selectTeamsChannels$ | ngrxPush"
                          [channel]="step?.value" (onChannelChange)="updateAction(action, stepIndex, $event)"
                          [alertName]="settingsForm.controls['name'].value">
                        </step-microsoft-teams-picker>
                      </ng-container>
                      <ng-container *ngSwitchCase="'variables'">
                        <org-variables-picker [variables]="selectOrganizationVariables()" [variable]="step?.value"
                          (onVariableChange)="updateAction(action, stepIndex, $event)"></org-variables-picker>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <step-provider-params-picker [provider]="action.form.value['provider']" [value]="step?.value"
                          (change)="updateAction(action, stepIndex, $event)"></step-provider-params-picker>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.SPEAKER_PICKER">
                    <step-speaker-selector [value]="step.value"
                      (change)="updateAction(action, stepIndex, $event)"></step-speaker-selector>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.HTTP_REQUEST">
                    <step-http-request [value]="step.value"
                      [variablesAutoComplete]="selectVariablesAutoComplete$|async"
                      (change)="updateAction(action, stepIndex, $event)"></step-http-request>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.ARM_DISARM_PICKER">
                    <alert-groups-picker [alertGroups]="selectAlertGroups$|ngrxPush" [alertGroupId]="step?.value"
                      (onAlertGroupSelected)="updateAction(action, stepIndex, $event)">
                    </alert-groups-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.EVENT_ENABLE_TOGGLE_PICKER">
                    <event-enable-toggle-picker [events]="selectAllOrganizationEvents$|ngrxPush"
                      [eventId]="step?.value" (onEventSelected)="updateAction(action, stepIndex, $event)">
                    </event-enable-toggle-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="StepType.REMOTE_IO_PICKER">
                    <remote-ios-picker [remoteIosDetails]="step?.value"
                      (onEventSelected)="updateAction(action, stepIndex, $event)">
                    </remote-ios-picker>
                  </ng-container>
                </ng-container>
                <div *ngIf="step.suffixText" class="step-suffix">{{ step.suffixText|translate }}</div>
              </ng-container>
            </div>
            <div class="alert-icon-button icon-16 svg-fill-gray c-p flex-row center-center"
              *ngIf="i !== 0 || (i === 0 && !!actions[i].actionType || actions[i].actionType === 0)"
              (click)="deleteAction(i)">
              <span class="ui-icon-delete"></span>
            </div>
          </div>
          <div *ngIf="i < actions.length - 1" class="w-100 flex-row space-between-center">
            <div class="flex-row center-center alert-icon-button icon-16 svg-fill-gray">
              <mat-icon svgIcon="plus"></mat-icon>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div *ngIf="selectedAlertFlow && currentStep >= selectedAlertFlow?.steps?.length
  && (!!actions[actions.length - 1]?.actionType || actions[actions.length - 1]?.actionType === 0)"
      class="icon-16 flex-row start-center">
      <div class="flex-row center-center alert-icon-button c-p" (click)="addAction()">
        <mat-icon svgIcon="plus"></mat-icon>
      </div>
    </div>
  </div>
</ng-container>
